/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext, useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";
import * as Sentry from "@sentry/react";
import { Helmet } from "react-helmet";
import PageSyncCal from "../../../components/Layout/PageSyncCal";
import Heading from "../../../components/Layout/Heading";
import { OuterContainerStyles } from "../../../components/Layout/Typography";
import GenericTable from "./Components/GenericTable";
import NoData from "../../../components/NoData";
import NewNoData from "../../../components/NoData/NewNoData";
import { SERVICES } from "../../../components/Layout/Services";
import { get } from "../../../components/Layout/ApiHandler/apihandler";
import Button from "../../../components/Layout/Button";
import Loader from "../../../components/Loader/Loader";

const LOADER_DELAY = 1000;
const PAGE = "page";
const DEFAULT_PAGE_SIZE = 10;

const tableHeaders = [
  "S.No.",
  "Report Name",
  "Generated At",
  "Status",
  "Action",
];

function DownloadReports() {
  const TITLE = "Download Reports - BSG ContributionAdmin";
  const [downloadData, setDownloadData] = useState({});
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const getDownloadReports = async () => {
    try {
      setIsLoading(true);
      const url = `${
        SERVICES.GET_DOWNLOAD_REPORTS
      }?pageNumber=${0}&pageSize=${DEFAULT_PAGE_SIZE}`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        // console.log(data);
        setDownloadData(data.data);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      Sentry.captureException(error);
      setIsLoading(false);
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  const handlePageChange = async (selectedPage) => {
    setCurrentPage(selectedPage);
    try {
      setIsLoading(true);
      const url = `${SERVICES.GET_DOWNLOAD_REPORTS}?pageNumber=${selectedPage}&pageSize=${DEFAULT_PAGE_SIZE}`;
      const response = await get(url);

      if (response && response.ok) {
        const data = await response.json();
        setDownloadData(data.data);
      } else {
        console.error("Failed to fetch contribution data");
        setIsLoading(false);
      }
    } catch (error) {
      Sentry.captureException(error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };
  // const openExcelInNewTab = async (downloadInfoId) => {
  //   try {
  //     const match = downloadInfoId.match(/-(\d+)$/);
  //     if (match) {
  //       const extractedNumber = match[1];
  //       const url = `${SERVICES.GET_DOWNLOAD_REPORTS}/${extractedNumber}/resultUrl`;
  //       const response = await get(url);
  //       if (response.ok) {
  //         const data = await response.json();
  //         // console.log("Line 122", data);
  //         window.open(data?.data?.signedS3Url, "_blank");
  //       } else {
  //         console.error("API Error:", response);
  //       }
  //     } else {
  //       // console.error("API Error:", response);
  //     }
  //   } catch (error) {
  //     Sentry.captureException(error);
  //   }
  // };

  const openExcelInNewTab = async (downloadInfoId) => {
    try {
      const url = `${SERVICES.GET_DOWNLOAD_REPORTS}/${downloadInfoId}/resultUrl`;
      const response = await get(url);
      if (response.ok) {
        const data = await response.json();
        // console.log("Line 122", data);
        window.open(data?.data?.signedS3Url, "_blank");
      } else {
        console.error("API Error:", response);
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  // const handleReload = () => {
  //   // setCurrentPage(0);
  //   handlePageChange(0);
  //   // getDownloadReports();
  // };
  useEffect(() => {
    getDownloadReports();
  }, []);
  useEffect(() => {
    if (downloadData.content) {
      const updatedTableData = downloadData.content.map((item, index) => {
        return {
          "S.No.": index + 1 + currentPage * DEFAULT_PAGE_SIZE,
          "Report Name": item?.name,
          "Generated At": item?.updatedAt,
          Status: item?.status,
          Action: (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {item.status === "COMPLETED" &&
              item.result &&
              item.result.s3Url ? (
                <Button onClick={() => openExcelInNewTab(item?.id)}>
                  Download
                </Button>
              ) : (
                <Button disabled>Download</Button>
              )}
            </Box>
          ),
        };
      });

      setData(updatedTableData);
    }
  }, [downloadData.content]);
  return (
    <div style={{ width: "100%", overflowX: "auto", overflowY: "hidden" }}>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <PageSyncCal />
      <Heading title="Download Reports" />
      <OuterContainerStyles marginTop="24px" marginBottom="24px">
        <div style={{ padding: "24px" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "24px",
            }}
          >
            {/* <Button cancel onClick={handleReload}>
              Reload
            </Button> */}
          </Box>
          {/* <GenericTable tableData={Data} headers={tableHeaders} /> */}
          {data?.length ? (
            <GenericTable
              tableData={data}
              data={downloadData}
              headers={tableHeaders}
              onPageChange={handlePageChange}
            />
          ) : (
            !data?.length && <NewNoData />
          )}
        </div>
        {isLoading && <Loader />}
      </OuterContainerStyles>
    </div>
  );
}
export default DownloadReports;
